/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/profileCard.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE, GET_ROLES, UPDATE_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";
import { capitalCase } from "change-case";
const is = require("is_js");
import { GET_BAND } from "../graphql/getBand.query";

import { AppNavigatorService } from "../../appNavigatorService";
import { useState } from "react";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface IMyProfileCardMethods extends IPluginMethodMap {
  getMyProfile(args: any): Promise<any>;
}

export class MyProfileCardService implements IAgentPlugin {
  readonly methods: IMyProfileCardMethods;

  constructor() {
    this.methods = {
      getMyProfile: this.getMyProfile.bind(this),
    };
  }

  async getMyProfile(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { getCode } = require("iso-3166-1-alpha-2");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });

        let band;
        if (is.existy(localStorage?.band)) {
          band = localStorage?.band;
        }
        let role = "";
        const appNavSrv = getAppNavService().whoAmI();
        appNavSrv
          .then((resolvedValue: any) => {
            const UserRole = resolvedValue.whoami;
            role = UserRole;
          })
          .catch((error: any) => {
            console.error(error);
          });
        if (res?.data) {
          console.log(`profile data`, res.data?.getMyProfile?.email);
          let userEmail = res.data?.getMyProfile?.email;
          let country = res?.data?.getMyProfile?.address?.country;
          const isISO2CountryCode = (code: any) => {
            var pattern = /^[A-Za-z]{2}$/;
            return pattern.test(code);
          };
          const territories = [
            "American Samoa",
            "Anguilla",
            "Bermuda",
            "British Virgin Islands",
            "Cayman Islands",
            "Cook Islands",
            "Falkland Islands",
            "Faroe Islands",
            "Gibraltar",
            "Greenland",
            "Jersey",
            "Montserrat",
            "Niue",
            "Norfolk Island",
            "Northern Mariana Islands",
            "Saint Barthélemy",
            "Saint Helena",
            "Saint Martin",
            "Saint Pierre and Miquelon",
            "Sint Maarten",
            "Tokelau",
            "Turks and Caicos Islands",
            "U.S. Virgin Islands",
            "Wallis and Futuna",
          ];
          if (
            !isISO2CountryCode(getCode(country)) &&
            !territories.includes(country)
          ) {
            const update = await client.mutate({
              mutation: UPDATE_MY_PROFILE,
              variables: {
                input: {
                  address: {
                    country: null,
                  },
                },
              },
              fetchPolicy: "no-cache",
            });
          }
          const _res = await client.query({
            query: GET_MY_PROFILE,
            fetchPolicy: "network-only",
          });
          const roles = await client.query({
            query: GET_ROLES,
            variables: {
              email: userEmail,
            },
            fetchPolicy: "network-only",
          });
          const res1 = await client.query({
            query: GET_BAND,
            variables: {
              filter: {
                bandName: band,
              },
            },
            fetchPolicy: "network-only",
          });
          console.log("roles==>", roles?.data?.getAUsersRoles);
          const _data: any = await this.getFormattedProfile(
            _res.data?.getMyProfile,
            roles?.data?.getAUsersRoles,
            res1?.data?.getBand,
            role
          );
          return {
            ...(_data || {}),
            tweetyProps: this.formatFormProps(
              config.TWEETY_PROPS,
              _res.data?.getMyProfile,
              roles.data?.getAUsersRoles
            ),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    // return {...(config || {})}
  }

  private async getFormattedProfile(
    data: any,
    roles: any,
    band?: any,
    role?: any
  ) {
    console.log("getFormattedProfile line 73==>", data, roles);
    let _profileInfo: any = {
      title: null,
      subtitle: null,
      image: data?.image ? data?.image : "",
      description: data?.bio,
      listItems: [
        {
          key: "email",
          title: "Email Address",
          subTitle: data?.email,
          icon: "https://img.icons8.com/fluency/96/mail.png",
        },
        {
          key: "phoneNumber",
          title: "Contact Number",
          subTitle: data?.primaryContactNo,
          icon: "https://img.icons8.com/fluency/96/phone.png",
        },
        {
          key: "whatsAppNo",
          title: "WhatsApp Number",
          subTitle: data?.whatsAppNo,
          icon: "https://img.icons8.com/fluency/96/whatsapp.png",
        },
        {
          key: "dob",
          title: "DOB",
          subTitle: data?.dob,
          icon: "https://img.icons8.com/fluency/96/calendar.png",
        },
        {
          key: "gender",
          title: "Gender",
          subTitle: data?.gender,
          icon: "https://img.icons8.com/fluency/96/mars-symbol.png",
        },
        {
          key: "address1",
          title: "Address Line 1",
          subTitle: data?.address?.addressLine1,
          icon: "https://img.icons8.com/fluency/96/map-marker.png",
        },
        {
          key: "address2",
          title: "Address Line 2",
          subTitle: data?.address?.addressLine2,
          icon: "https://img.icons8.com/fluency/96/map-marker.png",
        },
        {
          key: "address3",
          title: "Address Line 3",
          subTitle: data?.address?.addressLine3,
          icon: "https://img.icons8.com/fluency/96/map-marker.png",
        },
        {
          key: "city",
          title: "City",
          subTitle: data?.address?.city,
          icon: "https://img.icons8.com/fluency/96/building-with-rooftop-terrace.png",
        },
        {
          key: "state",
          title: "State",
          subTitle: data?.address?.state,
          icon: "https://img.icons8.com/fluency/96/region-code.png",
        },
        {
          key: "country",
          title: "Country",
          subTitle: data?.address?.country,
          icon: "https://img.icons8.com/fluency/96/geography.png",
        },
        {
          key: "zipcode",
          title: "Zip Code",
          subTitle: data?.address?.zipcode,
          icon: "https://img.icons8.com/fluency/96/map-marker.png",
        },
      ],
      buttons: [
        {
          key: "edit",
          title: "Update Profile",
          color: "secondary",
          isPresent: role !== "masq" ? true : band?.profileUpdateChange,
        },
      ],
      initialData: {
        firstName: data?.firstName,
        lastName: data?.lastName,
        avatar: data?.image,
        phoneNumber: data?.primaryContactNo,
        whatsAppNo: data?.whatsAppNo,
        gender: data?.gender,
        dob: data?.dob,
        address1: data?.address?.addressLine1,
        address2: data?.address?.addressLine2,
        address3: data?.address?.addressLine3,
        city: data?.address?.city,
        state: data?.address?.state,
        country: data?.address?.country,
        zipcode: data?.address?.zipcode,
        roles: roles?.roles,
      },
    };
    if (data?.firstName || data?.lastName) {
      const _first_name = data?.firstName ? capitalCase(data?.firstName) : "";
      const _last_name = data?.lastName ? capitalCase(data?.lastName) : "";
      _profileInfo.title = `${_first_name} ${_last_name}`;
    }
    return _profileInfo;
  }

  private formatFormProps(formProps: any, data: any, roles: any) {
    let _res: any = formProps;
    _res.initialData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      phoneNumber: data?.primaryContactNo,
      whatsAppNo: data?.whatsAppNo,
      avatar: data?.image,
      gender: data?.gender,
      dob: data?.dob,
      address1: data?.address?.addressLine1,
      address2: data?.address?.addressLine2,
      address3: data?.address?.addressLine3,
      city: data?.address?.city,
      state: data?.address?.state,
      country: data?.address?.country,
      zipcode: data?.address?.zipcode,
      roles: roles?.roles,
    };

    return _res;
  }

  private async isEditEnabled() {
    const srv = getWhoamiSrv();
    const user = await srv?.whoAmI();
    console.log(`user in profile service`, user);
    let formatted = true;
    if (user?.whoami === "admin") {
      formatted = false;
    }
    return formatted;
  }
}
